<template>
  <div class="kye-search-pager">
    <section class="search-pager-warp">
      <a v-if="option.back"
         style="height:28px;line-height:28px;display:inline-flex;cursor:pointer;"
         @click="goBack">
        <i class="layout layout-yemianfanhui search-pager-iconback"></i>
        <span class="title">
          {{option.comeBackTitle || '返回'}}
          <user-access :showAccess="option.showAccess" :showNotice="option.showNotice" />
        </span>
      </a>
      <span class="title" v-else>
        {{this.option.title}}
        <user-access :showAccess="option.showAccess" :showNotice="option.showNotice" />
      </span>
      <slot name="afterTitle"></slot>
      <div :style="pagerStyle">
        <div v-if="option.route"
             class="pager-wrap">
          <el-button icon="layout layout-first"
                     class="btn-text"
                     type="text"
                     :disabled="firstDisabled()"
                     @click="goFirst">
          </el-button>
          <el-button icon="layout layout-previous"
                     class="btn-text"
                     type="text"
                     hotkey="ctrl+←"
                     :disabled="previousDisabled()"
                     @click="goPrevious">
          </el-button>
          <kye-number v-model.number="curPage"
                      style="width:40px;"
                      :clearable="false"
                      :min="1"
                      :max="total()"
                      :disabled="pageDisabled()"
                      @focus="isBlur = false"
                      @blur="pageBlur">
          </kye-number>
          <span>/ {{total()}}</span>
          <el-button icon="layout layout-next"
                     class="btn-text"
                     type="text"
                     hotkey="ctrl+→"
                     :disabled="nextDisabled()"
                     @click="goNext(true)">
          </el-button>
          <el-button icon="layout layout-last"
                     class="btn-text"
                     type="text"
                     :disabled="lastDisabled()"
                     @click="goLast">
          </el-button>
        </div>
        <el-input v-if="option.formFields && option.formFields.length > 0"
                  v-bind="option.formFieldsInputProps"
                  v-on="option.formFieldsInputEvent"
                  ref="formFieldsInput"
                  v-model.trim="searchInput"
                  class="search-wrap"
                  :title="searchInput"
                  :placeholder="selectField.placeholder"
                  @keyup.enter.native="searchClick">
          <template v-if="option.formFields.length === 1"
                    slot="prepend">
            {{ selectField.label }}
          </template>
          <el-select v-else
                     v-bind="option.formFieldsSelectProps"
                     v-on="option.formFieldsSelectEvent"
                     ref="formFieldsSelect"
                     slot="prepend"
                     style="width:84px;"
                     :value="selectField.propertyName"
                     @input="searchChange">
            <el-option v-for="item in option.formFields"
                       :key="item.propertyName"
                       :label="item.label"
                       :value="item.propertyName">
            </el-option>
          </el-select>
          <kye-button slot="append"
                     type="primary"
                     v-bind="option.formFieldsButtonProps"
                     v-on="option.formFieldsButtonEvent"
                     ref="formFieldsButton"
                     icon="layout layout-search1"
                     :disabled="!searchInput"
                     @click="searchClick">查询
          </kye-button>
        </el-input>
      </div>
      <div class="tools-wrap">
        <slot></slot>
        <div v-if="tools"
             ref="tools"
             style="flex:1;display:flex;">
          <tool-list ref="toolList"
                     :active="false"
                     :tools="tools"
                     :wrap-style="toolsWrapStyle">
          </tool-list>
          <kye-button v-if="option.unitSwitch"
                      type="text"
                      class="switch-unit-button"
                      icon="layout layout-fms-genghuan"
                      @click="handleSwitchUnit">单位切换</kye-button>
        </div>
      </div>
    </section>
    <p class="line"></p>
    <custom-filter v-if="option.method && option.searchCode"
                   ref="genericDialog"
                   :module="option"
                   @close="showGenericDialog(false)"
                   @submit="handleGenericSubmit">
    </custom-filter>
  </div>
</template>

<script>
  import moment from 'moment'
  import { intersection } from 'lodash'
  import { ENV } from '@/public/config'
  import mixins from '../../mixins'
  import createStoreModule from '../../store/modules/queryTable/factory'
  import { localPageSize, getMenuIdByRoute } from '../../utils'
  import CustomFilter from './custom-filter.vue'
  import userAccess from './user-access'
  import {
    HTTP_ACTION,
    getQueryPager,
    perfectVos,
    perfectRows,
    mapSectionValueList
  } from './utils'

  export default {
    name: 'search-pager',
    mixins: [mixins],
    components: { CustomFilter, userAccess },
    props: {
      option: {
        type: Object,
        default: () => ({})
      },
      tools: Array
    },
    data () {
      return {
        id: '',
        curPage: 0,
        isBlur: true,
        esFlag: 'Y',
        searchInput: '',
        selectField: {},
        tag: this.$route.meta.tag,
        pagerStyle: { minWidth: '24px', display: 'flex' },
        toolsWrapStyle: { flex: 1, display: 'flex', justifyContent: 'flex-end' }
      }
    },
    created () {
      this.initProps()
    },
    activated () {
      // 多个keep-alive底层触发，导致非当前页签的路由更新
      const isEqual = this.$route.meta.tag === this.tag
      if (this.option.method && isEqual) {
        // 针对 unpager 是函数情况处理动态显示/隐藏分页展示
        if (typeof this.option.unpager === 'function' && this.hidePager()) {
          this.$set(this.option, 'route', null)
          return
        }

        // 分页隐藏不执行分页初始化操作
        if (this.hidePager()) {
          return
        }

        this.searchInput = ''
        this.id = this.$route.params.id || this.id
        this.setPage()
        this.setPageRoute()
        this.getGenericSearchFields()
      }
    },
    mounted () {
      if (this.option.formFields && this.option.formFields.length === 1) {
        let dom = this.$el.querySelector('.search-wrap > .el-input-group__prepend')
        dom.style.padding = '0 8px'
      }
    },
    computed: {
      menuId () {
        if (this.option.menuId) {
          return this.option.menuId
        }
        let menu = getMenuIdByRoute(this.$store, this.$route)
        return menu && menu.id
      },
      queryTableAction () {
        return this.$store.state.queryTable.$action
      },
      pagerConf () {
        let obj = this.$store.state.queryTable[this.option.module]
        return obj ? obj.pager : {}
      }
    },
    methods: {
      showGenericDialog (val = true) {
        this.$refs.genericDialog.show = val
      },
      initProps () {
        this.option.title = this.option.title || this.$route.meta.title
        // 详情 通用查询
        if (this.option.method) {
          this.option.back = this.option.back || this.tag
          if (!this.hidePager()) {
            this.option.idKey = this.option.idKey || 'id'
            this.option.module = this.option.module || this.option.method
            this.id = this.$route.params.id
            this.setPage()
            this.setPageRoute()
            // if (!this.option.route) {
            //   let path = this.$route.matched[1].path.replace(/:\w+/, '')
            //   this.option.route = id => {
            //     let oldQuery = this.$route.query
            //     let query = this.pagerConf.query && this.pagerConf.query[id]
            //     return {
            //       path: `${path}${id}`,
            //       query: { ...oldQuery, ...query }
            //     }
            //   }
            // }
            if (this.option.formFields && this.option.formFields.length) {
              this.pagerStyle.minWidth = '540px'
              this.selectField = this.option.formFields[0]
            } else {
              this.pagerStyle.minWidth = '226px'
            }
          }
          this.getGenericSearchFields()
        }
      },
      async replaceRouter (id, page) {
        if (id) {
          let fn = this.option.beforeRouteUpdate
          if (fn && typeof fn === 'function') {
            let val = await fn(id)
            if (!val) {
              return false
            }
          }
          this.id = id
          this.curPage = page
          this.$router.replace(this.option.route(id))
          return true
        }
        return false
      },
      total () {
        let ids = this.pagerConf.ids
        if (ids && ids.includes(this.id)) {
          return this.pagerConf.total
        }
        return 0
      },
      pageDisabled () {
        let ids = this.pagerConf.ids
        return !(ids && ids.length > 0)
      },
      previousDisabled () {
        let ids = this.pagerConf.ids
        return !this.isBlur || !(ids && ids.indexOf(this.id) > 0)
      },
      nextDisabled () {
        let id = this.id
        let ids = this.pagerConf.ids
        return !this.isBlur || !(ids && ids.includes(id) && ids.indexOf(id) < ids.length - 1)
      },
      firstDisabled () {
        let id = this.id
        let ids = this.pagerConf.ids
        return !this.isBlur || !(ids && ids.includes(id) && ids[0] !== id)
      },
      lastDisabled () {
        let ids = this.pagerConf.ids
        if (!ids) {
          return true
        }
        let id = this.id
        let lastId = ids[ids.length - 1]
        return !this.isBlur || !(ids.includes(id) && lastId !== id)
      },
      // 从缓存里删除该条数据
      deleteById (ids, index) {
        this.pagerConf.total -= 1
        ids.splice(index, 1)
        let pager = { total: this.pagerConf.total, ids }
        this.$store.commit(this.queryTableAction.updatePager(this.option.module), pager)
        let module = this.$store.state.queryTable[this.option.module]
        if (module && module.query[0] && module.query[0].res) {
          let res = module.query[0].res
          module.query[0].res.rowTotal -= 1
          module.query[0].res.rows.splice(index, 1)
          this.$store.commit(this.queryTableAction.setQuery(this.option.module), { res, index: 0 })
        }
      },
      getComebackWhiteList () {
        if (!ENV) {
          return []
        }
        const lookup = window.__ERPLOOKUP__ ? window.__ERPLOOKUP__.find(x => x.code === 'sys_frontend_comeback_white_list') : null
        const envMap = lookup && lookup.value
        if (!envMap) {
          return []
        }
        const config = envMap.find(e => e.lookupCode === ENV) || {}
        return config.lookupValue ? config.lookupValue.split(',') : []
      },
      goBack () {
        // 自定义返回按钮事件
        window.___ERP_SET_COME_BACK_STATUS__()
        let backUrl = this.option.back
        const moduleTag = this.$router.currentRoute.meta.tag
        // const fnFirst = ['/coo-allocation', '/coo-dispatch', '/coo-mix', '/coo-operation']
        const fnFirst = this.getComebackWhiteList()
        // 特殊场景, 优先走自己配置的backUrl
        const specialModule = fnFirst.some(x => (moduleTag && moduleTag.indexOf(x) === 0))
        if (this.option.backFnFirst || specialModule) {
          console.info('%c*****ERP-Searchpage:特殊场景(白名单或者backFnFirst为true)不走autoBack,走原逻辑', 'color: #8b60f0')
          if (typeof backUrl === 'function') {
            backUrl()
            return
          }
          this.$router.replace(backUrl)
          return
        }
        if (window.___ERP_AUTO_COME_BACK__ && window.___ERP_AUTO_COME_BACK__()) {
          console.info('%c*****ERP-Searchpage:走autoComeBack返回', 'color: #8b60f0')
          return
        }
        // 因为上面autoBack包含了自定义backUrl逻辑, 所以不执行fn逻辑直接回模块首页地址, 如果不配置back选项也默认回模块首页
        if ((backUrl && typeof backUrl === 'function') || !backUrl) {
          const _path = this.$router.currentRoute.path
          const resolveRoute = this.$router.resolve(_path).route
          backUrl = resolveRoute.meta.tag
        }
        console.info('%c*****ERP-Searchpage:走comeback返回的option', 'color: #8b60f0')
        this.$router.replace(backUrl)
      },
      goPrevious () {
        let ids = this.pagerConf.ids
        let index = ids.indexOf(this.id)
        let id = ids[index - 1]
        this.replaceRouter(id, index)
      },
      // 详情点击 “删除” 按钮，显示下一条
      goNext (inner = false) {
        let ids = this.pagerConf.ids
        let index = ids.indexOf(this.id)
        let id = ids[index + 1]
        if (inner) {
          this.replaceRouter(id, index + 2)
          return
        }
        let page = index + 1
        // 详情页通用需求：当删除的是最后一条时，如果集合中只有当前这一条，则跳转到列表页，否则跳转到上一条
        if (!id) {
          if (ids.length < 2) {
            this.$router.push(this.tag)
            return
          }
          id = ids[index - 1]
          page = index
        }
        if (this.replaceRouter(id, page)) {
          this.deleteById(ids, index)
        }
      },
      // 财务模块需求：自己控制 next 行为
      goNext2 (isDelete, isLastGoList) {
        let ids = this.pagerConf.ids
        let index = ids.indexOf(this.id)
        let id = ids[index + 1]
        let page = isDelete ? index + 1 : index + 2
        // 当删除的是最后一条时，如果集合中只有当前这一条，则跳转到列表页，否则跳转到上一条
        if (isLastGoList && !id) {
          if (ids.length < 2) {
            this.$router.push(this.tag)
            return
          }
          id = ids[index - 1]
          page = index
        }
        if (this.replaceRouter(id, page)) {
          if (isDelete) {
            this.deleteById(ids, index)
          }
        }
      },
      goFirst () {
        let id = this.pagerConf.ids[0]
        this.replaceRouter(id, 1)
      },
      goLast () {
        let ids = this.pagerConf.ids
        let index = ids.length
        let id = ids[index - 1]
        this.replaceRouter(id, index)
      },
      pageBlur () {
        if (typeof this.curPage === 'number' && this.curPage > 0 && this.curPage <= this.total()) {
          let id = this.pagerConf.ids[this.curPage - 1]
          if (id && id !== this.id) {
            this.replaceRouter(id, this.curPage)
          }
        } else {
          this.$message.warning('请输入合适的数字')
        }
        this.isBlur = true
      },
      searchChange (val) {
        this.selectField = this.option.formFields.find(v => v.propertyName === val)
      },
      searchClick () {
        if (!this.searchInput) {
          return
        }
        let vos = this.option.formFields.find(v => v.propertyName === this.selectField.propertyName).vos
        if (vos && vos.length) {
          let vo = vos.find(v => v.propertyName === this.selectField.propertyName)
          if (vo) {
            vo.values = [this.searchInput]
          }
        }
        // 替换搜索按钮的默认的通用查询接口
        if (this.option.onSearch) {
          this.$store.commit('SET_LOADING', true)
          this.option.onSearch(vos).then(res => {
            this.handleSearchData(res)
            this.$store.commit('SET_LOADING', false)
          }).catch(_ => this.$store.commit('SET_LOADING', false))
        } else {
          this.genericSubmit({ generic: { vos } }, HTTP_ACTION.FORM, this.option.axios)
        }
      },
      handleCommand (btn) {
        if (btn.type === 'link') {
          let route = typeof btn.func === 'function' ? btn.func(btn) : btn.func
          this.$router.push(route)
        } else {
          btn.func && btn.func(btn)
        }
      },
      btnDisabled (disabled) {
        return (typeof disabled === 'function') ? disabled() : !!disabled
      },
      authDisabled ({ disabled, auth }) {
        return (auth && !this.permission.menus.includes(auth)) || this.btnDisabled(disabled)
      },
      handleSearchData (res, data = {}, init) {
        // 容错后台数据
        res = perfectRows(res)
        if (res.rows && res.rows.length) {
          // 扁平化 区间列
          mapSectionValueList(res.rows, this.option.sectionOption)
          if (!this.hidePager()) {
            let pager = getQueryPager(this.option.idKey, res.rows)
            this.$store.commit(this.queryTableAction.updatePager(this.option.module), pager)
            this.$store.commit(this.queryTableAction.setQuery(this.option.module), { data, res, index: 0 })
            if (init) {
              let id = this.$route.params.id
              this.id = id
              this.curPage = pager.ids.indexOf(id) + 1
              this.$emit('change', res)
            } else {
              this.$emit('change', res)
              this.replaceRouter(pager.ids[0], 1)
            }
          } else {
            this.$emit('change', res)
          }
        } else if ((!res.rows || !res.rows.length) && !init) {
          this.$message.warning(this.option.noDataMsg || '无数据')
          this.$emit('change', res)
        }
      },
      handleGenericSubmit (data) {
        this.genericSubmit(data, HTTP_ACTION.GENERIC)
      },
      async genericSubmit (data, action, axios, init) {
        if (!data.generic || !data.generic.vos) {
          data.generic = { vos: [] }
        }
        Object.assign(data, { elasticsearchFlag: this.esFlag, page: 1, pageSize: localPageSize(this) })
        // 后台排序
        let sort = this.option.defaultSort
        if (sort && sort.keys && sort.keys.length) {
          let index = this.esFlag === 'Y' ? 0 : 1
          data.orderByClauses = [
            {
              field: sort.keys[index],
              orderByMode: sort.order === 'ascending' ? 0 : 1
            }
          ]
        }
        let fn = this.option.beforeFormSubmit
        if (fn && typeof fn === 'function' && fn(data, action) === true) {
          return
        }
        perfectVos(data.generic.vos)
        // 日期范围拦截
        let promise = this.dateRangeIntercept(data.generic.vos)
        if (promise) {
          try {
            await promise
          } catch (e) {
            return
          }
        }
        if (this.option.searchCode) {
          data.menuId = this.menuId
          data.genericSearchCode = this.option.searchCode
        }
        if (!init && this.option.method && !this.hidePager()) {
          this.saveGenericParams(data)
        }
        fn = this.option.beforeHttpAxios
        if (fn && typeof fn === 'function') {
          axios = fn(action, this.option.method, data)
        }
        this.$store.commit('SET_LOADING', true)
        try {
          let res = await this.$http(this.option.method, data, axios ? { axios } : null)
          this.handleSearchData(res, data, init, axios)
        } finally {
          this.$store.commit('SET_LOADING', false)
        }
      },
      // 自定义查询配置
      async getFormFields (res) {
        if (this.option.formFields && this.option.formFields.length) {
          let opt = this.option.formCode
          opt = opt && res.find(v => v.searchCode === opt)
          if (opt) {
            try {
              // 如果用户保存了自定义查询，需要获取自定义查询公共配置
              // 容错处理：没有返回正确的个性模板，则返回公共模板
              let userArr = JSON.parse(opt.fieldContent || '[]')
              if (!userArr || !userArr[0] || typeof userArr[0] === 'string') {
                let comRes = await this.$http('system.genericSearch.get', { id: opt.id })
                userArr = JSON.parse(comRes.fieldContent)
              }
              let errors = []
              this.option.formFields.forEach(v => {
                if (!v.vos) {
                  let obj = userArr.find(k => k.propertyName === v.propertyName)
                  if (obj) {
                    v.label = v.label || obj.label
                    v.placeholder = v.placeholder || obj.placeholder
                    v.vos = [{
                      propertyName: obj.propertyName,
                      columnName: obj.columnName,
                      columnType: obj.columnType,
                      operation: obj.operation
                    }]
                  } else {
                    errors.push(`[${v.propertyName}: ${v.label}]`)
                  }
                }
              })
              if (errors.length) {
                errors = errors.join() + '，缺少通用查询配置'
                this.$message.error(errors)
                console.error(errors)
              }
            } catch (e) {
            }
          }
        }
      },
      // 点部配置
      async getDeptFields (res) {
        let opt = this.option.deptSearchCode
        opt = opt && res.find(v => v.searchCode === opt)
        if (opt) {
          try {
            let conf = JSON.parse(opt.fieldContent || '{}')
            if (Array.isArray(conf) && conf.length) {
              conf = conf.reduce((s, v) => {
                s[`${v.type || 'list_'}${v.key}`] = v.dept || []
                return s
              }, {})
            }
            // if (this.$parent) {
            //   this.$parent._deptFilter_ = conf || {}
            // }
          } catch (e) {
          }
        }
      },
      // 通用查询配置、自定义查询配置、点部配置
      async getGenericSearchFields () {
        if (!this.option.searchCode && !this.option.formCode && !this.option.deptSearchCode) {
          this.registerStoreModule()
          return
        }
        let res = await this.$http('system.genericSearch.listByMenuId', { menuId: this.menuId })
        if (res && res.length) {
          this.labelFields = {}
          this.getFormFields(res)
          this.getDeptFields(res)
          // 通用查询配置
          // let opt = this.option.searchCode
          // opt = opt && res.find(v => v.searchCode === opt)
          // if (opt) {
          //   this.esFlag = opt.esFlag === '10' ? 'Y' : 'N'
          //   this.$refs.genericDialog.setGenericSearchFields(opt)
          //   this.setGenericFieldsLabel(opt.columnList)
          // }
          this.setGenericSearchFields(res)
        }
        this.registerStoreModule()
      },
      // 2021-10-26 通用查询个性设置
      setGenericSearchFields (res) {
        let code = this.option.searchCode
        // 当前通用查询数据
        let opt = code && res.find(v => v.searchCode === code)
        if (opt) {
          this.esFlag = opt.esFlag === '10' ? 'Y' : 'N'
          // 通用查询公共模板配置
          let userArr = JSON.parse(opt.fieldContent || '[]')
          let has = typeof userArr[0] === 'string'
          let originArr = opt.columnList.map(v => {
            const show = v.show === undefined ? true : !!v.show
            return {
              ...v,
              show,
              $show: show
            }
          })
          if (has && this.option.showGenericConfig) {
            // 2022-02-12 快照字段
            const snapshotObj = JSON.parse(opt.fieldSnapshot || '{}')
            // 如果没有交集，则取公共模板
            let keys = originArr.map(v => v.propertyName)
            keys = intersection(keys, userArr)
            if (keys && keys.length > 0) {
               // 用户保存的字段排前面
              let len = userArr.length + 1
              originArr.forEach(v => {
                const oiginStatus = v.show
                let index = userArr.indexOf(v.propertyName) + 1
                v.index = index || ++len
                v.show = index > 0
                // 检查是否有上个版本数据
                if (snapshotObj && Object.keys(snapshotObj).length) {
                  v.show = v.show || (!snapshotObj[v.propertyName] && oiginStatus)
                }
                v.$show = !!v.show
              })
              originArr.sort((a, b) => a.index - b.index)
            }
          }
          // 设置通用查询合并后的字段信息集合
          this.$set(this.option, 'configColumns', originArr)
          // 初始化通用查询
          this.$refs.genericDialog.setGenericSearchFields({ ...opt, columnList: originArr })
          // 如果有用户配置，则与通用查询公共配置合并
          has && this.$refs.genericDialog.mergeGenericFields()
          // 提取通用查询label，用于日期拦截提示语
          this.setGenericFieldsLabel(originArr)
        }
      },
      // 2022-02-12 检查是否是新同步字段
      updateGenericSearchFieldsStatus (oiginStatus, v, snapshotObj) {
        v.show = v.show || (!snapshotObj[v.propertyName] && oiginStatus)
      },
      // 详情页刷新浏览器，store 需要动态注册 queryTable
      registerStoreModule () {
        if (this.hidePager()) {
          return
        }
        let module = this.option.module
        let store = this.$store.state.queryTable[module]
        if (!store) {
          let tag = this.tag
          this.$store.registerModule(['queryTable', module], createStoreModule())
          this.$store.commit('queryTable/registerModule', { module, tag })
          let params = null
          try {
            params = JSON.parse(sessionStorage.getItem('GLOBAL_SEARCH_PAGER') || null)
            params = params && params[`${tag}?${module}`]
          } catch (e) {
          }
          params = params || {}
          let payload = { index: 0, data: params, res: { rowTotal: 0, rows: [] } }
          this.$store.commit(this.queryTableAction.setQuery(module), payload)
          this.$emit('stored')
          // 详情页刷新浏览器，根据本地参数进行一次搜索
          if (!this.option.unReload) {
            this.genericSubmit(params, HTTP_ACTION.FORM, this.option.axios, true)
          }
        } else {
          this.saveGenericParams(store.query && store.query[0] && store.query[0].data)
        }
      },
      // 详情页刷新浏览器，保存通用查询参数
      saveGenericParams (data) {
        if (data) {
          sessionStorage.setItem('GLOBAL_SEARCH_PAGER', JSON.stringify({ [`${this.tag}?${this.option.module}`]: data }))
        }
      },
      hidePager () {
        let unpager = this.option.unpager
        if (unpager && typeof unpager === 'function') {
          unpager = unpager()
        }
        return unpager
      },
      setPage () {
        let ids = this.pagerConf.ids
        this.curPage = (ids && ids.indexOf(this.id) + 1) || 0
      },
      // 设置翻页路由
      setPageRoute () {
        if (this.option.route) {
          return
        }

        let path = this.$route.matched[1].path.replace(/:\w+/, '')
        const route = id => {
          let oldQuery = this.$route.query
          let query = this.pagerConf.query && this.pagerConf.query[id]
          return {
            path: `${path}${id}`,
            query: { ...oldQuery, ...query }
          }
        }
        this.$set(this.option, 'route', route)
      },
      setGenericFieldsLabel (arr) {
        if (!arr || !arr.length) {
          return
        }
        let obj = arr.reduce((s, v) => {
          s[v.key] = v.columnDisplayName
          return s
        }, {})
        Object.assign(this.labelFields, obj)
      },
      dateRangeIntercept (vos) {
        if (!vos.length || !window.__ERPGLOABLECONFIG__.dateRangeIntercept || this.option.dateRangeIntercept === false) {
          return false
        }
        let arr = []
        let reg = /^\d{4}-/
        vos.forEach(v => {
          if (v.type === 'date' && v.operation === 'between' && v.values[0] && v.values[1] && reg.test(v.values[0])) {
            let start = v.values[0]
            let end = v.values[1]
            let day = moment(end).diff(moment(start), 'day')
            let text = ''
            if (day >= 360) {
              text = window.__ERPGLOABLECONFIG__.dateRange360
            } else if (day >= 180) {
              text = window.__ERPGLOABLECONFIG__.dateRange180
            } else if (day >= 90) {
              text = window.__ERPGLOABLECONFIG__.dateRange90
            }
            if (text) {
              arr.push(text.replace('$1', this.labelFields[v.propertyName] || this.labelFields[v.columnName]))
            }
          }
        })
        if (arr.length) {
          return this.$confirm(`${arr.join('，')}${window.__ERPGLOABLECONFIG__.dateRangeAppend}`, '提示')
        }
        return false
      },
      handleSwitchUnit () {
        let type = this.$store.getters.globalMoneyFormatType === 'CNY' ? 'ZH' : 'CNY'
        this.$emit('switch-unit', type)
        this.$store.commit('SET_GLOBAL_MONEY_FORMAT_TYPE', type)
      }
    }
  }
</script>

<style lang="scss">
  .kye-search-pager {
    position: sticky;
    top: 0;
    z-index: 10;
    background-color: white;
    margin: 0 -16px;
    padding: 0 16px 4px;

    .el-input__inner {
      padding-left: 8px !important;
      padding-right: 8px !important;
    }
    .el-input--suffix {
      .el-input__inner {
        padding-left: 8px !important;
        padding-right: 25px !important;
      }
    }
    .el-input-group__append > .el-button {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }

    .line {
      margin: 0 -16px;
      background-color: var(--g-border-color);
      height: 1px;
    }

    .search-pager-warp {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 4px 0;

      .pager-wrap {
        display: inline-block;
        padding-left: 24px;
        padding-right: 40px;
        .el-input__inner {
          text-align: center;
        }
        .el-button + .el-button {
          margin-left: 4px !important;
        }
      }
      .search-wrap {
        width: 315px;
        font-size: 12px;
        > .el-input__inner {
          border-radius: 0 !important;
        }
      }
      .tools-wrap {
        display: flex;
        flex: 1;
        max-height: 28px;
        .switch-unit-button {
          margin-left: 8px;
        }
      }
      .title {
        white-space: nowrap;
        color: var(--g-color-text);
        font-size: 14px;
        font-weight: bold;
        height: 28px;
        line-height: 28px;
      }
      .search-pager-iconback, .iconback {
        margin-right: 6px;
        font-size: 18px;
        color: var(--g-color-primary);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/query-table/search-pager.vue